import { useVerificationServiceCredentials } from '../api/queries/useVerificationServiceCredentials';
import { Loader } from '@/shared/components';
import { CyberityWidget } from './VerificationCyberityWidget';
import { useUserProfileInfo } from '@/entities/user';
import { VERIFICATION_SERVICES } from '@/shared/config';
import { SumsubWidget } from './VerificationSumsubWidget';

const VerificationDocumentsCheck = () => {
  const { userProfileInfoMap } = useUserProfileInfo();
  const {
    verificationServiceCredentials,
    isVerificationServiceCredentialsLoading,
    verificationServiceCredentialsError,
    refetchVerificationServiceCredentials,
  } = useVerificationServiceCredentials();

  const getNewAccessToken = async () => {
    const { data } = await refetchVerificationServiceCredentials();
    const accessToken = data?.widgetConfiguration.accessToken;
    return accessToken || '';
  };

  if (isVerificationServiceCredentialsLoading) {
    return <Loader />;
  }

  if (verificationServiceCredentialsError) {
    return <div>Error</div>;
  }

  if (!verificationServiceCredentials || !userProfileInfoMap) {
    return <div>No credentials</div>;
  }

  if (
    verificationServiceCredentials.verificationServiceName?.toLowerCase() ===
    VERIFICATION_SERVICES.CYBERITY
  ) {
    return (
      <CyberityWidget
        widgetConfiguration={verificationServiceCredentials.widgetConfiguration}
        userProfile={userProfileInfoMap}
        getNewAccessToken={getNewAccessToken}
      />
    );
  }

  if (
    verificationServiceCredentials.verificationServiceName?.toLowerCase() ===
    VERIFICATION_SERVICES.SUMSUB
  ) {
    return (
      <SumsubWidget
        widgetConfiguration={verificationServiceCredentials.widgetConfiguration}
        getNewAccessToken={getNewAccessToken}
      />
    );
  }

  return (
    <div>
      Unknown verification service{' '}
      {verificationServiceCredentials.verificationServiceName}
    </div>
  );
};

export { VerificationDocumentsCheck };
